import ObjectFitImages from 'object-fit-images';
const images = document.querySelectorAll('.panel__image');

ObjectFitImages(images);
